import baseConfig from './baseConfig'
import {clientCsaveExtensions} from './csaveConfigs'
import type {DSConfig} from '../dsConfig'

const config = {
    ...baseConfig,
    runStylesGC: false,
    supportMobile: false,
    postUpdateOperation: false,
    loadsMiniSiteManager: true,
    documentDataFixer: 'responsiveDocument',
    isReadOnly: false,
    noUndo: false,
    disableCommonConfig: false,
    modulesList: [
        'branchesPublicAPI',
        'accessibilityPublicAPI',
        'dataModelPublicAPI',
        'featuresPublicAPI',
        'slotsPublicAPI',
        'statesPublicAPI',
        'triggersPublicAPI',
        'reactionsPublicAPI',
        'documentModePublicAPI',
        'remoteStructureMetaDataPublicApi',
        'renderPluginsPublicApi',
        'savePublicAPI',
        'componentPublicAPI',
        'innerElementsPublicAPI',
        'refComponentPublicAPI',
        'componentDetectorPublicAPI',
        'responsivePublicAPI',
        'breakpointsPublicAPI',
        'namedRangesPublicAPI',
        'responsiveStylesPublicAPI',
        'siteMetadataPublicAPI',
        'themeCssVariablesPublicAPI',
        'globalStylesPublicAPI',
        'cssStylePublicAPI',
        'snapshotPublicAPI',
        'pagePublicAPI',
        'scrollAnchorsPublicAPI',
        'siteSegmentsPublicAPI',
        'componentsMetaDataPublicAPI',
        'appControllerDataPublicAPI',
        'connectionsPublicAPI',
        'platformPublicAPI',
        'routersPublicAPI',
        'autosavePublicAPI',
        'biPublicAPI',
        'environmentPublicAPI',
        'actionsAndBehaviorsPublicAPI',
        'structurePublicAPI',
        'debugPublicAPI',
        'atomicScopesPublicAPI',
        'menuPublicAPI',
        'smartBoxesPublicAPI',
        'sectionOrderPublicAPI',
        'fontsPublicAPI',
        'mediaPublicAPI',
        'tpaPublicAPI',
        'pagesGroupPublicAPI',
        'siteMembersPublicAPI',
        'wixCodePublicAPI',
        'variantsPublicAPI',
        'accountPublicAPI',
        'transformationsPublicAPI',
        'transitionsPublicAPI',
        'errorsPublicAPI',
        'componentsLoaderPublicAPI',
        'appStudioWidgetsPublicAPI',
        'multilingualPublicAPI',
        'partnersPublicAPI',
        'variablesPublicAPI',
        'scopesPublicAPI',
        'patternsPublicAPI',
        'effectsPublicAPI',
        'deprecatedOldBadPerformancePublicAPI',
        'customCSSPublicAPI',
        'aiPublicAPI',
        'externalComponentsPublicAPI',
        'importExportPublicAPI',
        'responsiveFixersPublicAPI',
        'builderComponentsPublicAPI',
        'historyAPI',
        'mobileAlgoPublicApi',
        'editorFeaturesPublicAPI',
        'observablesPublicAPI',
        'contextsPublicAPI',
        'bindingsPublicAPI'
    ],
    extensionsList: [
        ...baseConfig.extensionsList,
        'mobileAlgo',
        'undoRedo',
        'metadata',
        'save',
        'lifecycle',
        'layoutCircuitBreaker',
        'viewerRuntime',
        'contactFormMetaData',
        'appBuilder',
        'sectionOrder',
        'documentToViewer',
        'wixapps',
        'accountInfo',
        'commonConfig',
        'seo',
        ...clientCsaveExtensions,
        'componentsByType',
        'partners',
        'componentsRegistry',
        'aiContent',
        'proactiveAssistance',
        'eventHandler',
        'fileUpload',
        'responsiveFixers',
        'measurements',
        'editorFeatures',
        'namedRanges',
        'contexts',
        'bindings'
    ],
    experimentalConfigOptions: {
        dm_fragments: {
            configOptions: {
                supportedFragments: {
                    ...baseConfig.experimentalConfigOptions.dm_fragments.configOptions.supportedFragments,
                    EditorFeatures: {
                        loadOnInit: true
                    }
                }
            }
        },
        dm_enforceStrictValidationEverywhere: {
            configOptions: {
                enforceStrictValidationEverywhere: true
            }
        },
        dm_enforceNoWhitelistDalStrictSchemaValidation: {
            configOptions: {
                enforceNoWhitelistDalStrictSchemaValidation: true
            }
        },
        dm_runPreSaveOperationInQueue: {
            configOptions: {
                runPreSaveOperationInQueue: true
            }
        },
        dm_disableSaveInTransaction: {
            configOptions: {
                disableSaveInTransaction: true
            }
        },
        dm_strictBlacklistBaselineForEmployees: {
            configOptions: {
                strictBlacklistBaselineForEmployees: true
            }
        }
    }
}

export default config as unknown as DSConfig
